import { create } from 'zustand';

interface ReviewState {
  // Selection state for bulk actions
  selectedQuestionIds: Set<string>;

  // UI state
  expandedQuestionId: string | null;
  editingQuestionId: string | null;
  editingResponse: string;

  // Actions
  selectQuestion: (questionId: string) => void;
  deselectQuestion: (questionId: string) => void;
  selectAll: (questionIds: string[]) => void;
  selectNone: () => void;
  clearSelection: () => void;
  toggleSelection: (questionId: string) => void;
  selectAllInFilter: (filteredQuestionIds: string[]) => void;

  expandQuestion: (questionId: string | null) => void;
  startEditing: (questionId: string, response: string) => void;
  updateEditingResponse: (response: string) => void;
  cancelEditing: () => void;
}

export const useReviewStore = create<ReviewState>((set) => ({
  selectedQuestionIds: new Set(),
  expandedQuestionId: null,
  editingQuestionId: null,
  editingResponse: '',

  selectQuestion: (questionId) =>
    set((state) => ({
      selectedQuestionIds: new Set([...state.selectedQuestionIds, questionId]),
    })),

  deselectQuestion: (questionId) =>
    set((state) => {
      const newSet = new Set(state.selectedQuestionIds);
      newSet.delete(questionId);
      return { selectedQuestionIds: newSet };
    }),

  selectAll: (questionIds) =>
    set({ selectedQuestionIds: new Set(questionIds) }),

  selectNone: () =>
    set({ selectedQuestionIds: new Set() }),

  clearSelection: () =>
    set({ selectedQuestionIds: new Set() }),

  toggleSelection: (questionId) =>
    set((state) => {
      const newSet = new Set(state.selectedQuestionIds);
      if (newSet.has(questionId)) {
        newSet.delete(questionId);
      } else {
        newSet.add(questionId);
      }
      return { selectedQuestionIds: newSet };
    }),

  selectAllInFilter: (filteredQuestionIds) =>
    set({ selectedQuestionIds: new Set(filteredQuestionIds) }),

  expandQuestion: (expandedQuestionId) => set({ expandedQuestionId }),

  startEditing: (questionId, response) =>
    set({
      editingQuestionId: questionId,
      editingResponse: response,
    }),

  updateEditingResponse: (editingResponse) => set({ editingResponse }),

  cancelEditing: () =>
    set({
      editingQuestionId: null,
      editingResponse: '',
    }),
}));
